import Product from './product';
import ProductUtils from './product-utils';

export default class ProductGoodies {
    constructor(data, skusInCart) {
        // console.log('ProductGoodies constructor ', data);
        // console.log('skusInCart', skusInCart);
        this.data = data;
        this._options = [];
        this._skusInCart = skusInCart;
    }

    get imageUrl() {
        return this.data.hasOwnProperty('imageUrl') ? this.data.imageUrl : '';
    }

    get name() {
        return this.data.hasOwnProperty('name') ? this.data.name : '';
    }

    get groupId() {
        return this.data.hasOwnProperty('groupId') ? this.data.groupId : '';
    }

    get url(){
        return this.data.hasOwnProperty('url') ? this.data.url : null;
    }

    get skus(){
        return this.data.hasOwnProperty('skus') ? this.data.skus : null;
    }

    get skusInCart(){
        return this._skusInCart;
    }

    set skusInCart(val){
        this._skusInCart = val;
    }

    get isInCart(){
        //console.log('is in cart', this.name, this._skusInCart && Object.keys(this._skusInCart).length)
        return this._skusInCart && Object.keys(this._skusInCart).length;
    }

    get productType(){
        return this.data.hasOwnProperty('productType') ? this.data.productType : null;
    }

    get lineId(){
        // NOTE: currently cart will only have one 
        return this.isInCart ? Object.keys(this._skusInCart)[0] : null;
    }

    get priceReference() {
        return this.data.hasOwnProperty('priceReference') ? this.data.priceReference : '';
    }

    get price() {
        return this.data.hasOwnProperty('price') ? this.data.price : '';
    }

    get priceRaw() {
        return this.data.hasOwnProperty('priceRaw') ? this.data.priceRaw : 0;
    }

    get showOptions(){
        return this._options.length > 1 ? true : false;
    }

    get hasOptions(){
        //return this._options.length > 1 ? true : false;
        const len = this._options.length;
        if(len > 1){
            return true;
        }
        // no options or only one options but no description
        return !len || (len === 1 && !this._options[0].option) ? false : true;
    }

    get options(){
        return this._options.length ? this._options : null;
    }

    set options(options){
        //console.log('inside set options', options)
        const skus = this.skus;
        const len = options.length;
        this._options = [];
        for(let i = 0; i < len; i++){
            if(skus && skus.includes(options[i]['sku'])){
                this._options.push(options[i]);
            }
        }
    }

    get mub() {
        return this.data.hasOwnProperty('mub') ? this.data.mub : null;
    }

    get mubJson() {
        return JSON.stringify(this.mub);
    }

    getOptionsForCard(plafond, allowZero){
        let options = [];
        const list = this._options;

        if(!list){
            return options;
        }
        //console.log('product goodies getOptionsForCard, list = ', list);
        const len = list.length;
        for(let i = 0; i < len; i++){
            //console.log('product goodies list[i] ', list[i]);
            const sku = list[i].sku;
            const name = ProductUtils.getOptionsText({options: list[i].option}, ', ', ' ');
            const quantity = allowZero ? (this._skusInCart && this._skusInCart[sku] ? this._skusInCart[sku] : 0) : (this._skusInCart && this._skusInCart[sku] ? this._skusInCart[sku] : 0) + 1;
            let maxQuantity = 1;
            // if we have a plafond, this is used in category mode
            if(plafond && plafond > 0){
                // use priceRaw to calculate how many units can be added 
                maxQuantity = Math.min(list[i].stock, quantity + Math.floor(plafond / this.priceRaw));
            }
            const data = {
                sku: sku,
                name: name.length ? name : this.name,
                quantity: quantity,
                maxQuantity: maxQuantity,
                stock: list[i].stock,
                type: this.productType,
                imageUrl: list[i].imageUrl,
            };

            options.push(new Product(data));
        }
        //console.log('product goodies getOptionsForCard, options = ', options);
        return options;
    }
}